import styles from "./EditProfile.module.css";
import frame from "../../assets/profileBackImg.png";
import profileImg from "../../assets/profileImg.png";
import cameraImg from "../../assets/cameraIcon.png";
import SubmitButton from "../../components/submitButton/SubmitButton";
import { AntdDropdown, AntdInput, AntdSubmit } from "../../components";
import React, { useEffect, useRef, useState } from "react";
import dummyImg from "../../assets/dummy.png";
import { useDispatch, useSelector } from "react-redux";
import { IMG_URL } from "../../store/Apis";
import { useNavigate } from "react-router-dom";
import AuthMiddleware from "../../store/Middlewares/AuthMiddleware";
import AlertAction from "../../store/Actions/AlertActions";
import { useTranslation } from "react-i18next";
import { TimePicker } from "antd";
import CategoriesMiddleware from "../../store/Middlewares/CategoriesMiddleware";
import plusIcon from "../../assets/plusIcon.png";
import { roles } from "../../config/roles";
import PhoneInput from "react-phone-number-input/input";
import moment from "moment";
import AutoCompleteAddress from "../../components/AutoCompleteAddress/AutoCompleteAddress";
import InputField from "../../components/input/InputField";

const EditProfile = () => {
  const { t, i18n } = useTranslation();

  const dispatch = useDispatch();

  const navigate = useNavigate();
  const user = useSelector((state) => state.AuthReducer.user);
  const categories = useSelector(
    (state) => state.CategoriesReducer.CategoryList
  );
  const role = localStorage.getItem("role");

  const [profileImg, setProfileImg] = useState(null);
  const hiddenFileInput = React.useRef();
  const handleClick = (event) => {
    hiddenFileInput.current.click();
  };
  const [profile_image, setprofile_image] = useState(user?.profile_image);

  const [firstName, setfirstName] = useState(user?.first_name);
  const [lastName, setlastName] = useState(user?.last_name);
  const [email, setemail] = useState(user?.email);
  const [number, setnumber] = useState(user?.contact_no);
  const [address, setaddress] = useState(null);
  const [state, setstate] = useState("");
  const [street, setstreet] = useState("");
  const [zipCode, setzipCode] = useState("");
  const [clearField, setClearField] = useState(false);
  const [MultipleAddresses, setMultipleAddresses] = useState(user?.addresses);
  const [selectedCategory, setSelectedCategory] = useState(user?.category_id);
  // const [StartTime, setStartTime] = useState(user?.working_start_time);
  // const [EndTime, setEndTime] = useState(user?.working_end_time);

  useEffect(() => {
    getCategories();
    getLanguage();
    console.log("user", user);
  }, []);
  const getLanguage = async () => {
    try {
      const language = localStorage.getItem("@selectedLanguage");
      i18n.changeLanguage(language);
    } catch (e) {
      console.log(e);
    }
  };

  const getCategories = () => {
    dispatch(CategoriesMiddleware.getCategories());
  };

  const OnPressUpdateProfile = () => {
    // let startTime = StartTime
    //   ? moment(StartTime, "h:mm:ss A").format("HH:mm:ss")
    //   : null;
    // let endTime = EndTime
    //   ? moment(EndTime, "h:mm:ss A").format("HH:mm:ss")
    //   : null;
    // if (!firstName || !lastName || !number) {
    //   // Alert.alert('Note', 'All fields are required!')
    //   dispatch(
    //     AlertAction.ShowAlert({ type: "error", message: "All fields required" })
    //   );
    // }
    // else if (role == roles.cleaner && startTime >= endTime) {

    //   dispatch(
    //     AlertAction.ShowAlert({
    //       type: "error",
    //       message: "Start time should be before End time",
    //     })
    //   );
    // }
    // else if (role == roles.cleaner && !StartTime || !EndTime || !selectedCategory) {
    //   dispatch(
    //     AlertAction.ShowAlert({ type: "error", message: "All fields required" })
    //   );
    // }
    // else {

    if(address){
      MultipleAddresses.push(address)
    }
    let userData = {
      Firstname: firstName,
      Lastname: lastName,
      pickImage: profileImg,
      ContactNumber: number,
      MultipleAddress: MultipleAddresses,
      selectedCategory: selectedCategory,
      // StartTime: startTime,
      // EndTime: endTime,
    };
    console.log("userData", userData);
    dispatch(AuthMiddleware.UpdateProfile(userData))
      .then((data) => {
        dispatch(
          AlertAction.ShowAlert({ type: "success", message: data?.message })
        );
        navigate("/profile");
      })
      .catch((err) => {
        console.log(err);
      });
    // }
  };

  const phoneFormat = (text) => {

    var cleaned = ("" + text).replace(/\D/g, "");
    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      var intlCode = match[1] ? "+1 " : "",
        number = [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join(
          ""
        );
      return number;
    }
  }


  const onAddNewAdd = (place) => {
    console.log('place', place);
    let currentLocation = {
      lat: place?.geometry?.location?.lat(),
      lng: place?.geometry?.location?.lng(),
      address: place?.formatted_address
    }
    setaddress(currentLocation)
  }


  const removeAddress = (index, id) => {
    if (id) {
      dispatch(AuthMiddleware.deleteAddress(id))
      const cpyAddress = [...MultipleAddresses]
      cpyAddress.splice(index, 1)
      setMultipleAddresses(cpyAddress)
    } else {
      const cpyAddress = [...MultipleAddresses]
      cpyAddress.splice(index, 1)
      setMultipleAddresses(cpyAddress)
    }
  };


  return (
    <div className={styles.profile_mainCon}>
      <h1>{t("Edit Profile")}</h1>
      <div className={styles.profile_subCon}>
        <div className={styles.profile_subLeftCon}>
          <div className={styles.profile_frame}>
            <img src={frame} />
          </div>
          <div className={styles.profile_mainProfile}>
            <div className={styles.profile_subProfile}>
              <img
                src={
                  profileImg
                    ? URL.createObjectURL(profileImg)
                    : profile_image
                      ? IMG_URL + profile_image
                      : dummyImg
                }
              />
            </div>
            <div className={styles.profile_cameraIcon}>
              <img src={cameraImg} onClick={handleClick} />
            </div>
            <input
              type="file"
              accept="image/*"
              onChange={(e) => setProfileImg(e.target.files[0])}
              ref={hiddenFileInput}
              style={{ display: "none" }}
            />
          </div>
        </div>
        <div className={styles.profile_subRightCon}>
          <div className={styles.heading}>
            <h2>{t("Edit Profile")}</h2>
          </div>
          <div className={styles.subContentRow}>
            <div className={styles.subContentColLeft}>
              <AntdInput
                onChange={(e) => setfirstName(e.target.value)}
                placeholder={firstName ? firstName : "John"}
                name={"first_name"}
                label={t("First Name")}
                rules={[
                  {
                    require: true,
                    type: "text",
                    message: "Please enter first name",
                  },
                ]}
              />
            </div>
            <div className={styles.subContentColRight}>
              <AntdInput
                onChange={(e) => setlastName(e.target.value)}
                placeholder={lastName ? lastName : "Smith"}
                name={"last_name"}
                label={t("Last Name")}
                rules={[
                  {
                    require: true,
                    type: "text",
                    message: "Please enter Last name",
                  },
                ]}
              />
            </div>
          </div>
          <AntdInput
            disabled={true}
            onChange={(e) => setemail(e.target.value)}
            placeholder={email ? email : "John@gmail.com"}
            name={"email"}
            label={t("Email")}
            rules={[
              {
                require: true,
                type: "email",
                message: "Please enter valid email",
              },
            ]}
          />
          {/* <AntdInput onChange={(e) => setnumber(e.target.value)} placeholder={number ? number : '+1 - 202-555-0194'} name={'contact_number'} label={t('Contact Number')} rules={[{ require: true, type: 'number', message: 'Please enter Number' }]} /> */}
          <div className={styles.phoneInput}>
            <label>{t("Contact Number")}</label>
            <PhoneInput
              className={styles.PhoneNumber}
              placeholder={number ? phoneFormat(number) : "+1 - 202-555-0194"}
              defaultCountry="US"
              // value={number}
              maxLength={16}
              onChange={setnumber}
            />
          </div>

          {role == roles.contractor ? MultipleAddresses?.map((item, index) => {
            return (
              <>
                <InputField
                  label={`Address ${index + 1}`}
                  placeholder={item.address}
                  disabled
                  crossIcon
                  onIconClick={() => removeAddress(index,item?.id)}
                  width='100%'
                />
                {/* <AutoCompleteAddress label={`Address ${index + 1}`} address={item.address} onSelectLocation={(places) => onSelectLocation(index, places)} /> */}
              </>
            );
          }) : null}

          {role == roles.contractor ?
            <>
              <AutoCompleteAddress
                label={'Address'}
                placeholder={'New Address'}
                onSelectLocation={(places) => onAddNewAdd(places)}
                setClearField={setClearField}
                clearField={clearField}
              />

              {/* <div className={styles.subContentRow}>
                <div className={styles.subContentColLeft}>
                  <AntdInput
                    onChange={(e) => {
                      setstate(e.target.value);
                    }}
                    value={state}
                    placeholder={"State"}
                    label={t("State")}
                    rules={[
                      {
                        require: true,
                        type: "text",
                        message: "Please enter first name",
                      },
                    ]}
                  />
                </div>
                <div className={styles.subContentColRight}>
                  <AntdInput
                    onChange={(e) => {
                      setzipCode(e.target.value);
                    }}
                    value={zipCode}
                    placeholder={"Zip Code"}
                    label={t("Zip Code")}
                    rules={[
                      {
                        require: true,
                        type: "number",
                        message: "Please enter Last name",
                      },
                    ]}
                  />
                </div>
              </div> */}
              <div className={styles.plusImg}>
                <img
                  onClick={() => {
                    if (!address) {
                      dispatch(
                        AlertAction.ShowAlert({
                          type: "warning",
                          message: t("Please Fill Address Fields"),
                        })
                      );
                    } else {
                      setMultipleAddresses(prevState => [...prevState, address])
                      setClearField(true)
                      setaddress(null)
                      // setRefresh(!Refresh);
                    }
                  }}
                  src={plusIcon}
                />
              </div>
            </>
            : null}

          {/* {user?.role == roles.cleaner ? (
            <>
              <AntdDropdown
                name={t("Category")}
                label={t("Category")}
                placeholder={user?.category?.name}
                onChange={(val) => setSelectedCategory(val)}
                options={categories?.map((item) => {
                  return { value: item?.id, option: item?.name };
                })}
              />
            </>
          ) : null} */}
          {/* {user?.role == roles.cleaner ?
            <label className={styles.workHours}>Work Hours</label>
            :
            null
          } */}
          {/* {user?.role == roles.cleaner ? (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
                marginTop: "10px"
              }}
            >
              <TimePicker
                use12Hours
                format="h:mm a"
                className={"datePickerWhiteBordered"}
                placeholder={
                  user?.working_start_time
                    ? user?.working_start_time
                    : "Start Time"
                }
                onChange={(time, timeString) => setStartTime(timeString)}
              />
              <text style={{ margin: "0% 2%" }}>To</text>
              <TimePicker
                use12Hours
                format="h:mm a"
                className={"datePickerWhiteBordered"}
                placeholder={
                  user?.working_end_time ? user?.working_end_time : "End Time"
                }
                onChange={(time, timeString) => setEndTime(timeString)}
              />
            </div>
          ) : null} */}

          <AntdSubmit
            className={styles.editBtn}
            text={t("Save Profile")}
            buttonStyle={{ width: "50%", height: "50px" }}
            onClick={() => {
              OnPressUpdateProfile();
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default EditProfile;
